<template>
  <div style="margin-top:30px;">
    <el-form ref="form" :model="form" :rules="rules" label-width="80px" :disabled="detailType=='details'">
      <el-form-item label="名称" prop="name" style="margin-right:15px">
        <el-input v-model.trim="form.name" placeholder="请输入名称" @change="(value)=>{form.name = value.replace(/\s/g,'')}" />
      </el-form-item>
      <el-form-item label="密码" prop="upass">
        <!-- 解决自动填充问题 -->
        <el-input type="password" style="position: fixed; bottom: -9999px;" />
        <el-input v-model="form.upass" type="password" autocomplete="new-password" placeholder="请输入密码，默认abcd1234" clearable />
      </el-form-item>
      <el-form-item label="手机号" prop="phone" style="margin-right:15px">
        <el-input v-model="form.phone" placeholder="请输入手机号" />
      </el-form-item>
      <!-- <el-form-item label="所属部门" prop="departmentCode" style="margin-right:15px">
              <el-cascader
                v-model="cascadeList"
                :options="cascadeData"
                :props="{ checkStrictly: true }"
                @change="changeCascade"
                clearable
              ></el-cascader>
            </el-form-item>-->
      <el-form-item label="角色" style="margin-right:15px" prop="roleCodeList">
        <!-- <el-checkbox-group v-model="form.roleCodeList">
          <el-checkbox v-for="role in roleList" :key="role.code" :label="role.code" border>
            {{ role.roleName }}
          </el-checkbox>
        </el-checkbox-group> -->
        <el-select v-model="form.roleCodeList" filterable placeholder="请选择角色" multiple>
          <el-option v-for="role in roleList" :key="role.code" :label="role.roleName" :value="role.code" />
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="funcCancel">
        取 消
      </el-button>
      <el-button type="primary" @click="funcSubmit">
        确 定
      </el-button>
    </div>
  </div>
</template>
<script>
import request from "@/utils/request";
export default {
  name: "PartyEdit",
  props: {
    cascadeData: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    // 校验手机号
    const validatePhone = (rule, value, callback) => {
      const phoneReg = /^[1][0-9]{10}$/;
      if (!phoneReg.test(value)) {
        callback(new Error("格式有误"));
      } else {
        callback();
      }
    };
    return {
      cascadeList: [],
      emptyForm: {},
      detailType: 'add',
      form: {
        partyType: "STAFF",
        name: "",
        upass: "",
        phone: "",
        branchCode: "",
        departmentCode: "",
        teamCode: "",
        roleCodeList: [],
      },
      roleList: [],
      rules: {
        name: [
          { required: true, message: "请输入名称", trigger: "blur" },
          {
            min: 1,
            max: 50,
            message: "长度在 1 到 50 个字符"
          },
        ],
        roleCodeList: [
          { required: true, message: "请选择角色", trigger: "blur" },
        ],
        departmentCode: [
          {
            required: true,
            message: "请选择所属部门",
            trigger: "blur",
          },
        ],
        branchCode: [
          {
            required: true,
            message: "请选择所属部门",
            trigger: "blur",
          },
        ],
        phone: [
          {
            required: true,
            validator: validatePhone,
            trigger: "blur",
          },
        ],
      },
    };
  },
  created() {
    // 保存空表单对象
    this.emptyForm = JSON.parse(JSON.stringify(this.form));
  },
  methods: {
    setGroupCode(value) {
      this.form.branchCode = value[0];
      this.form.departmentCode = value[1];
      this.form.teamCode = value[2];
    },
    // 获取页面信息
    getInfo(detailType,code) {
      this.form = JSON.parse(JSON.stringify(this.emptyForm))
      this.$refs.form.resetFields()
      // 查询到数据之前先展示空表单
      this.detailType = detailType
      this.getRoleList();
      // 查询角色信息
      if(code){
        request({
          url: `/ntocc-basic-api/userLogin/${code}`,
          method: "get",
        }).then((response) => {
          this.form = JSON.parse(JSON.stringify(response.data));
          this.groupSelectValue = [];
          if (this.form.branchCode != "")
            this.groupSelectValue.push(this.form.branchCode);
          if (this.form.departmentCode != "")
            this.groupSelectValue.push(this.form.departmentCode);
          if (this.form.teamCode != "")
            this.groupSelectValue.push(this.form.teamCode);
          // this.$refs.groupSelect.setSelectValue(this.groupSelectValue)
        });
      }
    },
    // 查询角色列表
    getRoleList() {
      request({
        url: `/ntocc-basic-api/role`,
        method: "get",
        params: { type: 0 },
      }).then((response) => {
        this.roleList = response.data.records;
      });
    },
    // 提交
    funcSubmit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          const data = this.form;
          const rLoading = this.openLoading();
          let method = this.detailType=='add'?'post':'put'
          request({
            url: "/ntocc-basic-api/party",
            method: method,
            data,
          }).then((response) => {
            rLoading.close();
            this.$message({
              message: response.msg,
              type: "success",
            });
            this.$emit("fatherEditMethod");
          });
        } else {
          return false;
        }
      });
    },
    changeCascade(value) {
      this.form.branchCode = value[0] ? value[0] : "";
      this.form.departmentCode = value[1] ? value[1] : "";
    },
    // 取消
    funcCancel() {
      this.$emit("fatherCancelMethod", "edit");
    },
  },
};
</script>
<style lang="scss" scoped>
.dialog-footer {
  margin: 15px 0 15px 0;
  width: 175px;
  float: right;
}
</style>
